<div class="content content-md">
  <div >
    @if ((isBusy && !equipmentAssets.length)|| searchService.isSearching) {
      <app-overlay imgClass='cg-overlay-img'></app-overlay>
    }
    @if (!searchService.isSearching && !searchResults && equipmentAssets) {
      <div
        #scrollContainer
        [ngClass]="scrollContentClass"
        style="flex: none !important;"
        infinite-scroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="300"
        [scrollWindow]="false"
        (scrolled)="onScrollDown()"
        [attr.data-max-days]="this.maxDaysInStatus()"
        >
        <!--
        It's strange that we're repeating the "#content-list" with the for loop, this leads to many content-list ids.
        E2E depends on this id though.
        -->
        @for (asset of equipmentAssets; track asset) {
          <div id="content-list" class="list list-md equipment-asset-list-item">
            <div class="item item-block item-md margin-top-5 padding-bot-5">
              <div class="input-wrapper">
                <div class="list-label label label-md width-100">
                  <h2 class="asset-name ellipses-label">
                    {{asset.model_year}} {{asset.make}} {{asset.model}}
                  </h2>
                  <div class="asset-id ng-test-sublabel">
                    #{{asset.equipment_id}}
                  </div>
                  <div
                    [ngClass]="{'text-success': asset.is_available && !asset.on_rent, 'text-danger': asset.on_rent && !asset.is_available, 'text-warning': !asset.on_rent && !asset.is_available}"
                    class="customer-text status-text ng-test-available" [attr.data-days]="asset.days_in_same_status">
                    {{asset.rental_status}}
                    {{getDaysInSameStatus(asset.days_in_same_status)}}
                    @if (selectedCustomerCount() > 0 && asset.on_rent && asset.on_rent_to_customer) {
                      <span
                        class="customer-text" style="color: rgb(47, 165, 125) !important;"
                      >{{getLabelTranslation('On_rent_to_Customer')}}</span>
                    }
                  </div>
                  <div class="customer-text">
                    <div class="pin-container">
                      <img src="/assets/img/pin.png" alt="pin-icon" height="15" width="15" />
                    </div>
                    <div class="pin-container ng-test-address">
                      {{getAssetLocation(asset)}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="button-effect"></div>
            </div>
          </div>
        }
        @if (isLoadingMore) {
          <div style="text-align: center; padding: 20px;">
            <img src="/assets/img/loader-sm.gif" alt="Loading..." />
            <div style="margin-top: 10px; color: #666;">{{getLabelTranslation('Loading')}}</div>
          </div>
        }
      </div>
    }
    @if (searchResults) {
      <app-search-results />
    }
  </div>
</div>
